<template>
  <div>
    <div class="ft-16 font-bold mb15">{{ title }}</div>
    <DataTable :showHeader="false" :key="rows.length" :perpage.sync="query.per_page" :currentPage.sync="query.page"
      :total.sync="query.last_page" :rows.sync="rows" :table-fields="tableFields" :no-min-height="true">
      <template #cell(schedule_type)="{ type }">
        <span>{{ type?.name }}</span>
      </template>
      <template #cell(about)="{ about }">
        <span>{{ truncate(about, 15) }}</span>
      </template>
      <template #cell(participants)="{ participants }">
        {{truncate(participants?.map(({ name }) => name).join(', '), 20)}}
      </template>
      <template #cell(start_datetime)="{ start_datetime }">
        {{ moment(start_datetime).format('DD MMMM YYYY, HH:mm') }} WIB
      </template>
      <template #cell(end_datetime)="{ end_datetime }">
        {{ moment(end_datetime).format('DD MMMM YYYY, HH:mm') }} WIB
      </template>
      <template #cell(invited_by)="{ invited_by }">
        <div class="status"
          :style="`background-color: ${invited_by?.roles[0]?.color}1a;color: ${invited_by?.roles[0]?.color}`">
          {{ invited_by?.roles[0]?.name }}</div>
      </template>
      <template #cell(status)="{ status }">
        <div class="status" :class="status === 'Closed' ? 'grey' : 'yellow'">{{ status }}</div>
      </template>

      <template #table-action(edit)>
        <span></span>
      </template>
      <template #table-action(view)="{ id }">
        <button @click="toggleDetail(id)" class="btn btn-see rbe"><span class="icon-ico-eye"></span></button>
      </template>
    </DataTable>

    <div style="z-index: 9999;" class="overlay" :class="{ 'overlayshow': modal.overlay }"></div>
    <!--Popup-->
    <div style="z-index: 9999;" id="rbm-content" class="popup-wrapper" :class="{ 'showing': modal.content }">
      <div class="popup-card" style="max-height: 80dvh; overflow: hidden;">
        <div class="d-flex justify-content-between align-items-center">
          <div class="font-bold">Detail Schedule</div>
          <button @click="toggleDetail" class="btn btn-for-close"><span class="icon-ico-close"></span></button>
        </div>
        <div class="inner-scroll" style="max-height: 100dvh; overflow: scroll; padding-bottom: 15rem;">
          <div class="popup-item wb">
            <div class="row">
              <div class="col-sm-6 col-6">
                <div class="grey">Status</div>
                <div class="status" :class="detail?.status === 'Closed' ? 'grey' : 'yellow'">
                  {{ detail?.status }}</div>
              </div>
            </div>
          </div>
          <div class="popup-item wb">
            <div class="row">
              <div class="col-sm-6  col-6">
                <div class="grey">Schedule Type</div>
                <span v-if="detail?.type">{{ detail?.type.name || '-' }}</span>
              </div>
              <div class="col-sm-6 col-6">
                <div class="grey">About</div>
                <span>{{ detail?.about || '-' }}</span>
              </div>
            </div>
          </div>
          <div class="popup-item wb">
            <div class="row">
              <div class="col-sm-12">
                <div class="grey">Place</div>
                <span>{{ detail?.place || '-' }}</span>
              </div>
            </div>
          </div>
          <div class="popup-item wb">
            <div class="row">
              <div class="col-sm-6 col-6">
                <div class="grey">Start Date and Time</div>
                <span>{{ moment(detail?.start_datetime).format('DD MMM YYYY, HH : mm') }} WIB</span>
              </div>
              <div class="col-sm-6 col-6">
                <div class="grey">End Date and Time</div>
                <span>{{ moment(detail?.end_datetime).format('DD MMM YYYY, HH : mm') }} WIB</span>
              </div>
            </div>
          </div>
          <div class="popup-item wb">
            <div class="row">
              <div class="col-sm-12">
                <div class="grey">Participants</div>
                <div v-for="participant in detail?.participants" :key="participant.nik" class="status ori"
                  style="margin-right: 3px">{{ participant.name }}</div>
              </div>
            </div>
          </div>
          <div class="popup-item wb">
            <div class="row">
              <div class="col-sm-12">
                <div class="grey">Customer Name</div>
                <span>{{ detail?.customer_name || '-' }}</span>
              </div>
            </div>
          </div>
          <div class="popup-item">
            <div class="row">
              <div class="col-sm-12">
                <div class="grey">Goals</div>
                <span>{{ detail?.goals || '-' }}</span>
              </div>
            </div>
          </div>
          <div class="popup-item">
            <div class="row">
              <div class="col-sm-12">
                <div class="bg-yellow">
                  <div class="grey">Result</div>
                  <div class="result-schedule" v-if="detail?.result" v-html="detail?.result"></div>
                  <span v-else class="italic">-</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios';
import moment from 'moment'
import { truncate, showErrorMessage } from '@/utils';
import DataTable from "@/components/DataTable.vue";

export default {
  name: "DashboardSchedule",
  props: ['tableFields', 'endpointUrl', 'title', 'additionalParams'],
  components: {
    DataTable
  },
  data() {
    return {
      query: {
        per_page: 10,
        page: 1,
        last_page: 0,
      },
      rows: [],
      detail: null,
      modal: {
        overlay: false,
        content: false
      },
      moment,
      truncate
    }
  },
  methods: {
    async get() {
      try {
        const res = await axios.get(this.endpointUrl, {
          params: {
            ...this.query,
            ...this.additionalParams,
          }
        })
        this.query.last_page = Number(res?.data?.data?.last_page) || 0
        this.query.page = Number(res?.data?.data?.current_page) || 1
        this.rows = res.data.data.data || []
      } catch (err) {
        showErrorMessage(err)
      }
    },
    toggleDetail(id) {
      this.detail = ['number', 'string'].includes(typeof id) ? this.rows.find(schedule => schedule.id == id) : null
      this.modal.overlay = !this.modal.overlay
      this.modal.content = !this.modal.content
    },
  },
  async created() {
    await this.get()
  },
  computed: {
    queryWatcher() {
      return {
        page: this.query.page,
        per_page: this.query.per_page,
        search: this.query.search,
      }
    }
  },
  watch: {
    queryWatcher(newVal, oldVal) {
      if (newVal.perpage !== oldVal.perpage || newVal.search !== oldVal.search) {
        this.query.page = 1
      }
      this.get()
    },
  }
}
</script>
